import IDoctor, { ICfm } from '@/interfaces/doctor';
import { IUnitClient } from '@/interfaces/client';
import ITeam from '@/interfaces/teams';
import { toUpperCase } from '@/helpers/toUpperCase';

export default class DoctorModel {
  public id: string;
  public nome: string;
  public crm: string;
  public crmUF: string;
  public email: string;
  public telefone: string;
  public celular: string;
  public ativo: boolean;
  public motivoInativacao: string;
  public unidadesCliente: IUnitClient[];
  public times: ITeam[];
  public cfm: ICfm;

  constructor(_initialValues?: IDoctor) {
    const initialValues = _initialValues || {
      id: '',
      nome: '',
      crm: '',
      telefone: '',
      crmUF: '',
      celular: '',
      email: '',
      ativo: true,
      motivoInativacao: null,
      unidadesCliente: [],
      times: [],
      cfm: {
        nome: '',
        situacao: '',
        liberado: false,
        dataAtualizacaoCfm: '',
        tipoInscricao: '',
        ultimaIntegracao: '',
      },
    };

    this.id = initialValues.id;
    this.nome = initialValues.nome;
    this.crm = initialValues.crm;
    this.telefone = initialValues.telefone;
    this.crmUF = initialValues.crmUF;
    this.celular = initialValues.celular;
    this.email = initialValues.email;
    this.ativo = initialValues.ativo;
    this.motivoInativacao = initialValues.motivoInativacao;
    this.unidadesCliente = initialValues.unidadesCliente;
    this.times = initialValues.times;
    this.cfm = initialValues.cfm;
    if (!!this.cfm) {
      this.cfm.nome = this.nome;
    }
  }

  public validate(): boolean {
    return !!this.nome && !!this.crm && !!this.crmUF && !!this.email;
  }

  public toJson(): any {
    const unidadesCliente = this.unidadesCliente.map((item) => {
      return {
        id: item.id,
      };
    });

    return {
      id: this.id,
      nome: toUpperCase(this.nome),
      crm: this.crm,
      email: toUpperCase(this.email),
      crmUF: this.crmUF,
      telefone: this.telefone,
      celular: this.celular,
      unidadesCliente,
      times: this.times,
      cfm: this.cfm,
      ativo: this.ativo,
    };
  }
}
